export default __webpack_public_path__ + "static/media/Akinakes of the Ruinous Miasma.7aa4ed34.jpg";